import ApiService from '../services/ApiService'

const PermissionsService = {
  async getPermissions (rolId) {
    return ApiService.get(`/permissions/${rolId}`)
  }
}

export default PermissionsService
